import { Color, Spacing } from '@persona-id/design-tokens';
import { ReactNode, VFC } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { BORDER_RADIUSES, COLORS } from 'shared/styles/variables';
import styled, { css } from 'styled-components';

import { StyledIconDrag } from 'dashboard/lib/dnd/StyledIconDrag';
import useToggle from 'lib/hooks/useToggle';

const RouteItem = styled.div<{ isDragging: boolean; isDragDisabled: boolean }>`
  display: flex;
  align-items: flex-start;
  border-radius: ${BORDER_RADIUSES.rounded};
  padding-top: ${Spacing[3]};
  padding-bottom: ${Spacing[3]};
  background: ${Color.CoreSlate50};
  overflow-wrap: anywhere;

  ${({ isDragging }) => css`
    box-shadow: ${isDragging ? `1px 1px 5px 2px ${COLORS.indigo30}` : 'none'};
  `}

  transition: box-shadow 0.4s ease-in-out;
`;

const RouteIconDrag = styled(StyledIconDrag)`
  margin-left: ${Spacing[1]};
  margin-right: ${Spacing[1]};
`;

interface HoverableDraggableProps {
  draggableId: string;
  index: number;
  isDragDisabled: boolean;
  children: ReactNode;
}

const HoverableDraggable: VFC<HoverableDraggableProps> = ({
  draggableId,
  index,
  isDragDisabled,
  children,
}) => {
  const [isMouseOver, { enable: handleMouseEnter, disable: handleMouseLeave }] = useToggle(false);
  return (
    <Draggable draggableId={draggableId} index={index} isDragDisabled={isDragDisabled}>
      {(draggableProvided, draggableSnapshot) => (
        <RouteItem
          {...draggableProvided.draggableProps}
          {...draggableProvided.dragHandleProps}
          ref={draggableProvided.innerRef}
          isDragging={draggableSnapshot.isDragging}
          isDragDisabled={isDragDisabled}
          style={draggableProvided.draggableProps.style}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          {!isDragDisabled && <RouteIconDrag $active={isMouseOver} />}
          {children}
        </RouteItem>
      )}
    </Draggable>
  );
};

export default HoverableDraggable;
